import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import * as s from "react";
const a = (o, t) => /* @__PURE__ */ r.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: t, ...o, children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M15.22 16.28a.75.75 0 0 0 1.06-1.06L11.06 10l5.22-5.22a.75.75 0 0 0-1.06-1.06L10 8.94 4.78 3.72a.75.75 0 0 0-1.06 1.06L8.94 10l-5.22 5.22a.75.75 0 1 0 1.06 1.06L10 11.06l5.22 5.22Z" }) }), e = s.forwardRef(a);
export {
  e as F
};
//# sourceMappingURL=X20.BXgaZkFp.js.map
